import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, LineChart, Line,
} from "recharts";

export interface MissRateRow { label: string; miss_rate_pct: number; }
export interface AvgTimeRow { label: string; avg_time_sec: number; }
export interface CategoryWeaknessRow { category: string; missed: number; }
export interface SchoolCompareRow { school: string; avg_score: number; }
export interface GrowthRow { attempt: number; score: number; }

export function MissRateChart({ rows }: { rows: MissRateRow[] }) {
  return (
    <div className="card-dark p-4 h-72">
      <h3 className="text-sm uppercase tracking-wider text-steel-300 mb-2">Question miss rate</h3>
      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={rows}>
          <CartesianGrid stroke="#262b31" />
          <XAxis dataKey="label" stroke="#9aa3ad" hide />
          <YAxis stroke="#9aa3ad" />
          <Tooltip contentStyle={{ background: "#1f2630", border: "1px solid #363c44" }} />
          <Bar dataKey="miss_rate_pct" fill="#f25c00" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function AvgTimeChart({ rows }: { rows: AvgTimeRow[] }) {
  return (
    <div className="card-dark p-4 h-72">
      <h3 className="text-sm uppercase tracking-wider text-steel-300 mb-2">Average time per question (s)</h3>
      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={rows}>
          <CartesianGrid stroke="#262b31" />
          <XAxis dataKey="label" stroke="#9aa3ad" hide />
          <YAxis stroke="#9aa3ad" />
          <Tooltip contentStyle={{ background: "#1f2630", border: "1px solid #363c44" }} />
          <Bar dataKey="avg_time_sec" fill="#ffd23f" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function CategoryWeaknessChart({ rows }: { rows: CategoryWeaknessRow[] }) {
  return (
    <div className="card-dark p-4 h-72">
      <h3 className="text-sm uppercase tracking-wider text-steel-300 mb-2">Category weakness</h3>
      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={rows} layout="vertical">
          <CartesianGrid stroke="#262b31" />
          <XAxis type="number" stroke="#9aa3ad" />
          <YAxis dataKey="category" type="category" stroke="#9aa3ad" width={120} />
          <Tooltip contentStyle={{ background: "#1f2630", border: "1px solid #363c44" }} />
          <Bar dataKey="missed" fill="#fb7185" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function SchoolCompareChart({ rows }: { rows: SchoolCompareRow[] }) {
  return (
    <div className="card-dark p-4 h-72">
      <h3 className="text-sm uppercase tracking-wider text-steel-300 mb-2">School comparison · avg score</h3>
      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={rows}>
          <CartesianGrid stroke="#262b31" />
          <XAxis dataKey="school" stroke="#9aa3ad" />
          <YAxis stroke="#9aa3ad" />
          <Tooltip contentStyle={{ background: "#1f2630", border: "1px solid #363c44" }} />
          <Bar dataKey="avg_score" fill="#34d399" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function GrowthChart({ rows }: { rows: GrowthRow[] }) {
  return (
    <div className="card-dark p-4 h-72">
      <h3 className="text-sm uppercase tracking-wider text-steel-300 mb-2">Student growth across attempts</h3>
      <ResponsiveContainer width="100%" height="90%">
        <LineChart data={rows}>
          <CartesianGrid stroke="#262b31" />
          <XAxis dataKey="attempt" stroke="#9aa3ad" />
          <YAxis stroke="#9aa3ad" />
          <Tooltip contentStyle={{ background: "#1f2630", border: "1px solid #363c44" }} />
          <Line type="monotone" dataKey="score" stroke="#f25c00" strokeWidth={2} dot />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
